// extracted by mini-css-extract-plugin
export var autoExpand = "_24-b";
export var container = "_24-a";
export var containerWidth = "_24-8";
export var disabled = "_24-2";
export var error = "_24-3";
export var fullWidth = "_24-9";
export var highlightContainer = "_24-5";
export var inputWrapper = "_24-0";
export var small = "_24-1";
export var textarea = "_24-4";
export var validatedTextarea = "_24-6";
export var visuallyHidden = "_24-7";